import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Inbox, Trash2, Phone, Mail, MapPin, Calendar } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import api from '@/lib/api';
import { formatDate, statusInfo } from '@/lib/format';

const STATUSES = ['novo', 'em_contato', 'convertido', 'perdido'];

export default function Leads() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { api.get('/leads').then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const setStatus = async (lead, status) => {
    try { await api.put(`/leads/${lead.lead_id}/status?status=${status}`); toast.success('Status atualizado'); load(); }
    catch { toast.error('Erro ao atualizar'); }
  };
  const del = async (lead) => {
    try { await api.delete(`/leads/${lead.lead_id}`); toast.success('Lead removido'); load(); }
    catch { toast.error('Erro ao remover'); }
  };

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-display text-2xl font-semibold">Leads</h2>
        <p className="text-sm text-muted-foreground">Contatos recebidos pelo site para novas viagens.</p>
      </div>

      {loading ? <p className="text-muted-foreground">Carregando...</p> : items.length === 0 ? (
        <Card className="p-12 text-center"><Inbox className="h-8 w-8 mx-auto text-muted-foreground" /><p className="mt-3 text-muted-foreground">Nenhum contato recebido ainda.</p></Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="leads-list">
          {items.map((l) => {
            const si = statusInfo(l.status);
            return (
              <Card key={l.lead_id} className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-semibold">{l.nome}</h3>
                    <div className="mt-1 text-xs text-muted-foreground">{formatDate(l.created_at)}</div>
                  </div>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${si.cls}`}>{si.label}</span>
                </div>
                <div className="mt-3 space-y-1.5 text-sm text-muted-foreground">
                  {l.email && <div className="flex items-center gap-2"><Mail className="h-4 w-4" /> {l.email}</div>}
                  {l.telefone && <div className="flex items-center gap-2"><Phone className="h-4 w-4" /> {l.telefone}</div>}
                  {l.destino && <div className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {l.destino}</div>}
                  {l.periodo && <div className="flex items-center gap-2"><Calendar className="h-4 w-4" /> {l.periodo}</div>}
                </div>
                {l.mensagem && <p className="mt-3 text-sm bg-muted/50 rounded-lg p-3">{l.mensagem}</p>}
                <div className="mt-4 flex items-center gap-2">
                  <Select value={l.status} onValueChange={(v) => setStatus(l, v)}>
                    <SelectTrigger className="h-9" data-testid={`lead-status-${l.lead_id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{statusInfo(s).label}</SelectItem>)}</SelectContent>
                  </Select>
                  <Button variant="ghost" size="icon" onClick={() => del(l)}><Trash2 className="h-4 w-4 text-destructive" /></Button>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
